import React, { useRef, Fragment, memo } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ArrowRight, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
const travels = [{
  id: 1,
  location: 'Vietnam',
  title: 'Land of the Blue Dragon',
  image: 'https://images.unsplash.com/photo-1528127269322-539801943592?auto=format&fit=crop&q=80&w=800'
}, {
  id: 2,
  location: 'Dubai',
  title: 'City of Gold',
  image: 'https://images.unsplash.com/photo-1512453979798-5ea936a7fe48?auto=format&fit=crop&q=80&w=800'
}, {
  id: 3,
  location: 'Mumbai',
  title: 'The City of Dreams',
  image: 'https://images.unsplash.com/photo-1566552881560-0be862a7c445?auto=format&fit=crop&q=80&w=800'
}, {
  id: 4,
  location: 'Rishikesh',
  title: 'Yoga Capital',
  image: 'https://images.unsplash.com/photo-1592639296346-560c37a8f7f4?auto=format&fit=crop&q=80&w=800'
}, {
  id: 5,
  location: 'Kashmir',
  title: 'Paradise on Earth',
  image: 'https://images.unsplash.com/photo-1595867865332-acd54364542b?auto=format&fit=crop&q=80&w=800'
}, {
  id: 6,
  location: 'Dwarka',
  title: 'Kingdom of Krishna',
  image: 'https://images.unsplash.com/photo-1628668923083-ea798c800539?auto=format&fit=crop&q=80&w=800'
}];
export function TravelSection() {
  const containerRef = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: containerRef,
    offset: ['start end', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], [0, -50]);
  return <section id="travel" ref={containerRef} className="py-24 px-6 bg-zen-bg overflow-hidden" data-id="element-99">
      <div className="max-w-7xl mx-auto" data-id="element-100">
        <div className="flex justify-between items-end mb-16" data-id="element-101">
          <div data-id="element-102">
            <h2 className="text-5xl font-moon-dance text-zen-text mb-4" data-id="element-103">
              Travel Diaries
            </h2>
            <p className="text-zen-text/60" data-id="element-104">
              Fragments of memories from around the globe.
            </p>
          </div>
          <Link to="/travel-stories" className="hidden md:flex items-center gap-2 text-zen-accent hover:text-zen-accent-light transition-colors group" data-id="element-105">
            <span data-id="element-106">View all destinations</span>
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-107" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-108">
          {travels.map((trip, index) => <motion.div key={trip.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group relative h-[350px] rounded-2xl overflow-hidden cursor-pointer" data-id="element-109">
              <motion.div style={{
            y
          }} className="absolute inset-0" data-id="element-110">
                <img src={trip.image} alt={trip.location} className="w-full h-[120%] object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-111" />
              </motion.div>

              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-80 group-hover:opacity-90 transition-opacity" data-id="element-112" />

              <div className="absolute bottom-0 left-0 p-8 w-full transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300" data-id="element-113">
                <div className="flex items-center gap-2 text-white/80 text-sm mb-2" data-id="element-114">
                  <MapPin className="w-4 h-4" data-id="element-115" />
                  <span className="uppercase tracking-wider" data-id="element-116">
                    {trip.location}
                  </span>
                </div>
                <h3 className="text-2xl font-moon-dance text-white mb-4" data-id="element-117">
                  {trip.title}
                </h3>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-8 md:hidden text-center" data-id="element-118">
          <Link to="/travel-stories" className="inline-flex items-center gap-2 text-zen-accent" data-id="element-119">
            <span data-id="element-120">View all destinations</span>
            <ArrowRight className="w-4 h-4" data-id="element-121" />
          </Link>
        </div>
      </div>
    </section>;
}